import useMutation from "src/hooks/useMutation";

function useFileCreate() {
  return useMutation({
    path: "/api/v1/files",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: ``,
      shouldRevalidate: false,
    },
  });
}

export default useFileCreate;
